<template>
  <app-admin>
    <div class="container content clearfix">
      <loader ref="loader"/>
      <div class="flex-between">
        <h1>Группа {{group.name}}</h1>
        <!--<router-link :to="{name: 'GroupPlayers', params: { id: group.id }}" v-if="results.length != 0">-->
          <!--v-if="!(players.length == 0 && tests.length == 0)"-->
          <div class="btn" @click="showModal = !showModal">
            <font-awesome-icon icon="user-plus"/>
            Добавить участника в группу
          </div>
        <!--</router-link>-->
      </div>

      <group-modal v-if="showModal" @close="showModal = false"></group-modal>

      <div class="tests">
        <div>
          <ul>
            <li v-for="(test, index) in tests" @click="changeCurrTest(test)"
                :class="{active: currTest === test}" :key="test.id">
              Программа №{{index + 1}}
            </li>

            <router-link :to="{name: 'GroupTests', params: { id: group.id }}" tag="li" class="btn">

              <font-awesome-icon icon="plus"/>
              Добавить программу к группе
            </router-link>

          </ul>
          <p v-if="tests.length != 0">Название программы: «{{currTest.name}}»</p>
        </div>
      </div>

      <div class="no-players" v-if="results.length == 0 && tests.length == 0 && players.length == 0">
        <div class="text">
          В этой группе пока нет ни одного добавленного участника, не добавлен ни один тест.
          <br>
          Добавьте участника и тест
        </div>
        <router-link vm :to="{name: 'GroupPlayers', params: { id: group.id }} ">
          <div class="btn btn-lg">
            Добавить участника в группу
          </div>
        </router-link>
        <br><br>
        <router-link :to="{name: 'GroupTests', params: { id: group.id }}">
          <div class="btn btn-lg">
            Добавить тест к группе
          </div>
        </router-link>
      </div>

      <div v-if="results.length != 0">
        <table cellspacing="0" cellpadding="0" class="main-table">
          <thead>
          <tr>
            <th class="index">№</th>
            <th class="fio">ФИО участника</th>
            <th class="index">Баллы</th>
            <th class="index">Попытки</th>
            <th>Дата</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="results.length == 0 && players.length == 0">
            <td class="text-center" colspan="5">
              <em>В этой группе пока нет ни одного добавленного участника</em>
            </td>
          </tr>
          <tr v-for="(result, index) in results" :key="result.id">
            <td style="width: 40px;">{{(itemsPerPage*(currentPage-1)) + index+1}}</td>

            <router-link :to="{ name: 'Player', params: { id: result.player.id }}" tag="td" class="hover">
              {{result.player.last_name}} {{result.player.first_name}} {{result.player.middle_name}}
            </router-link>

            <td v-if="testScore">{{scorePoints(result.score, testScore)|| '0'}}</td>
            <td>{{result.attempt}}</td>
            <td>
              <span v-if="result.date_completed">{{result.date_completed | date('HH:mm, DD.MM.YY')}}</span>
              <span v-else>-</span>
            </td>
            <td>
              <font-awesome-icon icon="times"
                                 v-tooltip="{content: 'Исключить участника из группы', class: 'tooltip-custom'}"
                                 @click="removeFromGroup(result.player)"/>
            </td>
          </tr>
          </tbody>
        </table>
        <pagination v-if="results.length === 0" @change="setPageByPlayers" :itemsPerPage="itemsPerPage" :resultCount="resultCount" ref="pagination"/>

      </div>

      <div v-if="results.length == 0 && players.length != 0">
        <table cellspacing="0" cellpadding="0" class="main-table">
          <thead>
          <tr>
            <th class="index">№</th>
            <th class="fio">ФИО участника</th>
            <th class="index">Баллы</th>
            <th class="index">Попытки</th>
            <th>Дата</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="results.length == 0 && players.length == 0">
            <td class="text-center" colspan="5">
              <em>В этой группе пока нет ни одного добавленного участника</em>
            </td>
          </tr>
          <tr v-for="(player, index) in players" :key="player.id">
            <td style="width: 40px;">{{(itemsPerPage*(currentPage-1)) + index+1}}</td>

            <router-link :to="{ name: 'Player', params: { id: player.id }}" tag="td" class="hover">
              {{player.last_name}} {{player.first_name}} {{player.middle_name}}
            </router-link>

            <td>0</td>
            <td>0</td>
            <td>
              <span>-</span>
            </td>
            <td>
              <font-awesome-icon icon="times"
                                 v-tooltip="{content: 'Исключить участника из группы', class: 'tooltip-custom'}"
                                 @click="removeFromGroup(result.player)"/>
            </td>
          </tr>
          </tbody>
        </table>
        <pagination @change="setPageByPlayers" :itemsPerPage="itemsPerPage" :resultCount="resultCount" ref="pagination"/>

      </div>

      <div class="buttons">
        <router-link :to="{name: 'Groups'}">
          <div class="btn btn-light">
            <font-awesome-icon icon="angle-left"/>
            Вернуться к списку групп
          </div>
        </router-link>
      </div>
    </div>
  </app-admin>
</template>

<script>
  import GroupsService from '@/services/GroupsService'
  import TestsService from '@/services/TestsService'
  import PlayersService from '@/services/PlayersService'
  import Pagination from '@/components/Pagination'
  import GroupModal from '@/components/modal/GroupModal'

  export default {
    name: 'Group',
    components: {
      'pagination': Pagination,
      GroupModal
    },
    data () {
      return {
        showModal: false,
        currTest: {},
        orgSlug: '',
        testScore: '',
        tests: [],
        results: [],
        players: [],
        group: {
          name: '',
          theme: {
            name: ''
          }
        },
        currentPage: 1,
        itemsPerPage: 10,
        resultCount: 0
      }
    },
    methods: {
      removeFromGroup (player) {
        PlayersService.removePlayerFromGroup(this.group.id, player.id).then(
          (response) => {
            let playerIndex = this.results.findIndex(x => x.player.id === player.id)
            this.results.splice(playerIndex, 1)
            this.resultCount--
          }
        )
      },
      changeCurrTest (test) {
        this.currTest = test
        this.getTestResults(this.currTest.id)
      },
      setPage (pageNumber) {
        this.currentPage = pageNumber
        this.getTestResults()
      },
      setPageByPlayers (pageNumber) {
        this.currentPage = pageNumber
        if (!this.showOnlyInGroup) {
          this.getPlayers()
        } else {
          // пагинация чуваков в группе
          let index = this.currentPage * this.itemsPerPage - this.itemsPerPage
          this.players = this.playersInGroup.slice(index, index + this.itemsPerPage)
        }
      },
      getPlayers () {
        PlayersService.getPlayers(this.currentPage, this.itemsPerPage, this.filter).then(
          (response) => {
            this.players = response.results
            this.resultCount = response.count
          },
          (error) => {
            console.log(error)
          }
        )
      },
      getTestResults (testId) {
        this.$refs.loader.show()
        let id = this.$route.params.id
        TestsService.getTestResultsByGroupId(id, testId, this.currentPage, this.itemsPerPage, this.filter).then(
          (response) => {
            this.$refs.loader.hide()
            this.results = response
          }
        )
      },
      scorePoints (score, test) {
        let result = Math.floor(score * 100 / test)
        return result
      }
    },
    computed: {},
    mounted () {
      let id = this.$route.params.id
      this.$refs.loader.show()
      GroupsService.getGroup(id).then(
        (response) => {
          this.group = response
          this.$refs.loader.hide()
        }
      )
      PlayersService.getPlayersByGroupId(id).then(
        (response) => {
          this.players = response
        }
      )
      this.getPlayers()
      this.orgSlug = this.$store.getters.slug
      TestsService.getTestsByGroupId(id).then(
        (response) => {
          this.tests = response
          if (this.tests.length) {
            this.currTest = this.tests[0]
            this.getTestResults(this.currTest.id)
            TestsService.getTest(this.orgSlug, this.currTest.id).then(
              (response) => {
                this.testScore = response.score
              }
            )
          }
        }
      )
    }
  }
</script>

<style scoped lang="scss">
  .no-players {
    margin-top: 150px;
    text-align: center;
    .text {
      color: #666666;
      font-weight: 300;
      font-size: 1.5em;
      line-height: 2em;
      margin-bottom: 20px;
    }
  }

  .content {
    padding-bottom: 70px;
  }

  .buttons {
    position: absolute;
    padding: 15px 20px;
    left: 0;
    bottom: 0;
  }

  table.main-table {
    margin-bottom: 50px;
    tr {
      td, th {
        text-align: center;
        &:nth-child(1), &:nth-child(2) {
          text-align: left;
        }
      }
    }
    .remove {
      transform: scale(0.7);
    }
  }

  .tests {
    margin-bottom: 40px;
    p {
      font-size: 14px;
      font-weight: 300;
    }
    ul {
      padding: 0;
      list-style: none;
      font-size: 0;
      li {
        display: inline-block;
        padding: 15px 30px;
        box-sizing: border-box;
        color: #666;
        border: 1px solid $light-blue;
        border-right: none;
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: $blue;
        }
        &.active {
          background-color: $blue;
          color: #fff;
          border: 1px solid $blue;
        }
        &:first-child {
          border-radius: 6px 0 0 6px;
        }
        &:last-child {
          box-shadow: none;
          padding: 15px 30px;
          border-radius: 0 6px 6px 0;
          border: 1px solid $light-blue;
          color: #000;
          &:hover {
            color: $blue;
            svg path {
              fill: $blue;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/groups/Group.vue